module.exports = __webpack_public_path__ + "img/9.506f035f.jpg";